import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AppProviders } from '@/components/app-providers'
import { AppLayout } from '@/components/app-layout'
import { Suspense, lazy } from 'react'

// Lazy load pages for better code splitting
const Home = lazy(() => import('@/pages/Home'))
const Account = lazy(() => import('@/pages/Account'))
const AuthCallback = lazy(() => import('@/pages/AuthCallback'))
const Mines = lazy(() => import('@/pages/Mines'))

function App() {
  return (
    <Router>
      <AppProviders>
        <AppLayout>
          <Suspense fallback={<div className="h-screen w-full bg-black" />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/demo" element={<Home />} />
              <Route path="/account" element={<Account />} />
              <Route path="/auth" element={<Navigate to="/" replace />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/mines" element={<Mines />} />
            </Routes>
          </Suspense>
        </AppLayout>
      </AppProviders>
    </Router>
  )
}

export default App
